// src/pages/ContactPage.js
import ContactForm from "../components/ContactForm";

export default function ContactPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-primary font-oswald">
        Contact Us
      </h1>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Contact Form */}
        <div className="lg:w-1/2">
          <ContactForm />
        </div>

        {/* Direct Help Section */}
        <div className="bg-secondary p-6 rounded shadow text-dark lg:w-1/2">
          <h2 className="text-2xl font-bold mb-4 font-oswald">
            Need Direct Assistance?
          </h2>

          <p className="mb-6 font-open">
            You can also visit us in person! We're located at:
            <br />
            <strong>7433 1st Ave N, Birmingham, AL 35206</strong>
          </p>

          <div className="mb-6 font-open">
            <strong>Our Hours:</strong>
            <ul className="list-disc list-inside">
              <li>Sales: Mon-Sat, 9AM - 6PM</li>
              <li>Service: Mon-Sat, 8AM - 5PM</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
          <div className="mb-4">
            <iframe
              title="Moving the Chainz Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3160.277373437755!2d-86.73357382450554!3d33.5589629733468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8889116546c7e991%3A0x6e2b531fd6facdfb!2sMoving%20the%20Chainz!5e1!3m2!1sen!2sus!4v1748453757118!5m2!1sen!2sus"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded shadow"
            />
          </div>

          <a
            href="https://www.google.com/maps/dir/?api=1&destination=7433+1st+Ave+N,+Birmingham,+AL+35206"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-primary text-white font-bold py-3 px-6 rounded hover:bg-primary/90 transition"
          >
            Get Directions
          </a>
        </div>
      </div>
    </div>
  );
}
